import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { commonLabelConstants } from '../../constants/label-constants';

@Component({
  selector: 'app-delete-confirmation-dialog',
  templateUrl: './delete-confirmation-dialog.component.html',
  styleUrls: ['./delete-confirmation-dialog.component.scss']
})

export class DeleteConfirmationDialogComponent {

  action: string;
  name: string | undefined;
  imageSrc: any;
  isImageComponent: boolean = false;
  labelConstants: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { action: string, imagesrc?: any, isImageComponent?: any }) {
    this.action = data.action;
    this.imageSrc = data.imagesrc;
    this.isImageComponent = data.isImageComponent;
  }

  ngOnInit(): void {
    this.labelConstants = commonLabelConstants;
  }
}